<template>
  <router-view></router-view>
</template>
<script>
  export default {
    watch: {
		$route: function(to, from) {
		     window.scrollTo(0,0);
			//document.body.scrollTop = 0;
            //document.documentElement.scrollTop = 0;
		},
	},
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/App.vue